import ecNgModelService from './src/ec-ng-model.service';
import ecElementService from './src/ec-element.service';
import ecUtilService from './src/ec-util.service';
import ecAnimationService from './src/ec-animation.service';
import ecKeyboardService from './src/ec-keyboard.service';
import ecStringService from './src/ec-string.service';
import ecParserService from './src/ec-parser.service';
import ecPopupService from './src/ecPopupService/ec-popup.service';
import ecWindowManagerService from './src/ecWindowManagerService/ec-window-manager.service';
import ecDialogService from './src/ecDialogService/ec-dialog.service';
import ecSortService from './src/ec-sort.service';

import * as scroller from './src/scroll';
import objectHelpers from './src/object';
import styleHelpers from './src/style';
import numberHelpers from './src/number';
import mathHelpers from './src/math';
import attributeHelpers from './src/attribute';
import EcFilter from './src/EcFilter/index';

import { setVersionInEdicom } from '@edicom/common/edicom/setVersionInEdicom';
import { name, version } from './package.json';

setVersionInEdicom(name, version);

angular
  .module('commonEdicomComponents', [])
  .service('ecNgModelService', ecNgModelService)
  .service('ecElementService', ecElementService)
  .service('ecUtilService', ecUtilService)
  .service('ecAnimationService', ecAnimationService)
  .service('ecKeyboardService', ecKeyboardService)
  .service('ecStringService', ecStringService)
  .service('ecParserService', ecParserService)
  .service('ecPopupService', ecPopupService)
  .service('ecWindowManagerService', ecWindowManagerService)
  .service('ecDialogService', ecDialogService)
  .service('ecSortService', ecSortService)
  // declaramos con "function" y no "() => {}" porque angularjs necesita el constructor para instanciar los servicios:
  .service('ecObjectService', function() {
    return objectHelpers;
  })
  .service('ecStyleService', function() {
    return styleHelpers;
  })
  .service('ecNumberService', function() {
    return numberHelpers;
  })
  .service('ecMathService', function() {
    return mathHelpers;
  })
  .service('ecAttributeService', function() {
    return attributeHelpers;
  })
  .service('ecScrollService', function() {
    return scroller;
  })
  .service('EcFilter', function() {
    return EcFilter;
  });
